import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, Divider, Dialog, DialogActions, DialogContent, DialogContentText, 
    DialogTitle, Slide, CircularProgress, Card, CardContent, CardMedia, CardActions, TextField } from '@material-ui/core';
import white from '@material-ui/core/colors'
import { } from '@material-ui/icons';
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';
import { EventEmitter } from 'events';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
      },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 20,
        width: '75%',
        margin: 'auto'
    },
    textField: {
        paddingTop: 20,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
        
    },
    formControl: {
        margin: theme.spacing.unit * 3, 
        float: 'left',
        
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    card2: {
        maxWidth: 345,
        },
    cardMedia: {
        // height: 140,
        },
    media: {
        maxHeight: '100%',
        maxWidth: '100%',
        height: 'auto',
        display: 'inline-block',

        // paddingTop: '56.25%', // 16:9
    },
    modal: {
        position: 'fixed',
        zIndex: 5
    },
    card: {
        position: 'fixed',
        zIndex: 999,
        top: 80,
        right: 100,
        backgroundColor: '#3F51B5'
    }
})

const textColour = white;


class SitHwk extends Component{
    constructor(props){
        super(props)
        this.state = {
            answers: [],
            open: false,
            imgOpen: false,
            activeImg: '',
            ansImg: '',
            src: '',
            tags: [],
            timeRemaining: '-- : -- : --',
            timerComplete: false,
            ansOpen: false,
            questions: []
        }
    }

    testName = this.props.match.params.ref.replace('-', ' ')

    componentDidMount(){
        // const testName = this.props.match.params.ref.replace('-', ' ')
        const testsRef = db.collection('Tests').doc(this.testName)
        var imgArr = []
        var data
        var id
        var tags = [] 
        testsRef.get()
            .then( async doc => {
                if (!doc) {
                    // console.log('No such test exists.')
                } else {
                    // console.log('THERE WAS TEST DATA HERE') 
                    data = doc.data().data
                    id = doc.id
                    
                }
                data.questions.forEach( async question => {
                    if (question.file != null) { 
                        var storageRef = creds.fb.storage();
                        var imgRef =  storageRef.ref('/images/' + id + '/' + question.file)
                        const url = await imgRef.getDownloadURL()
                        // console.log(url)
                        // console.log(imgArr)
                            imgArr.push({url: url, question: data.questions.indexOf(question)})
                            var img = document.getElementById(question.id)
                            img.src = url
                        }
                    tags.push(question.tags)
                    question.answers.forEach( async answer => { 
                        if (answer.file != false  && answer.file != null){
                            var storageRef = creds.fb.storage();
                            var imgRef =  storageRef.ref('/images/' + id + '/' + answer.value)
                            const url = await imgRef.getDownloadURL()
                            // console.log(url)
                            // console.log(imgArr)
                            imgArr.push({file:answer.file, url: url, question: data.questions.indexOf(question)})
                            var img = document.getElementById(answer.file)
                            if (img) {
                                img.src = url
                                this.setState({...this.state})
                            }
                        }
                    })
                })
                
                var output
                var ref = await db.collection('Users').where('UID', '==', sessionStorage.getItem('uid')).get()
                ref.forEach(doc => {
                    output = doc.data().displayName
                })
                if (data.timer != 'N/A'){
                    this.timeConversion(data.timer)
                }
                

                
                this.setState({
                    testTitle: id,
                    test: data,
                    timeLimit: data.timer,
                    images: imgArr,
                    tags: tags,
                    loaded: true,
                    myName: output
                })
            })
            .catch( error => {
                console.error('There was an error!: ' + error)
            })
        
    }


    timeConversion = (rawInput) => { 
        // console.log(rawInput)
        if (rawInput != undefined){
            var hrs = parseInt(rawInput.slice(0,2))
            var mins = parseInt(rawInput.slice(3,5))
            var hrsConv = hrs * 3600
            var minsConv = mins * 60
            var totalSecs = hrsConv + minsConv
            this.setState({
                ...this.state,  
                totalSecs: totalSecs
            })
        }
        // window.alert('HRS: ' + hrs + ' MINS: ' + mins) //DEBUG
        this.timer()
    }

    timer = () =>  { 
        var interval = setInterval(() => {
            if (!this.state.timerComplete) { 
            var totalSecs = this.state.totalSecs
                if (totalSecs == 0) { 
                    return this.setState({
                        ...this.state,
                        timerComplete: true
                    })
                }
                totalSecs = totalSecs - 1
                var minsLeft = totalSecs/60
                var hrsLeft = 0
                var secsLeft = totalSecs%60
                if (minsLeft > 60) {
                    hrsLeft = Math.floor(minsLeft/60)
                }
                var output = hrsLeft + 'hrs ' + Math.floor(minsLeft) + 'mins ' + secsLeft + 'secs'
                // console.log(output)
                this.setState({
                    ...this.state,
                    timeRemaining: output,
                    totalSecs: totalSecs
                })
            } else {
                if (this.state.timerComplete){
                    clearInterval(interval)
                    this.fillAnswers()
                    this.timeCompleteAlert()
                    if (!this.state.taskLockedAlert) { 
                        this.finish()
                        this.handleClickOpen()
                    }
                }
            }
        }, 1000)
    }

    timeCompleteAlert = () => { 
        this.setState({
            ...this.state,
            timeRemaining: '-- : -- : --',
            taskLockedAlert: true
        })
    }
 
    fillAnswers = () => { 
        var questions = this.state.test.questions
        var answers = this.state.answers 
        var needFilling = []

        // console.log('LENGTH: ' + length, 'AMOUNT TO FILL: ' + (length - this.state.answers.length))
        // console.log(this.state.answers, this.state.test.questions)

        if (questions.length != answers.length){ 
            questions.forEach(question => { 
                var fill = true
                answers.forEach(answer => { 
                    if (question.id == answer.id){
                        fill = false
                    }
                })
                if (fill == true) {
                    needFilling.push({id: question.id, value: 'NULL'})
                }

            })
            // console.log('NEED FILLING : ' , needFilling, answers, answers.concat(needFilling))
            this.setState({
                ...this.state,
                answers: answers.concat(needFilling)
            })
        }
        

    }

    handleChange = name => event => {
        this.setState({
          [name]: event.target.value,
        });
      };

    pickAnswer = id => event => { 
        const ans = {
            id: id,
            value: event.target.value
        };
        var newArr = this.state.answers.filter(function(answer){
            return answer.id != [id]
        }).concat(ans)
        // console.log(newArr)
        this.setState({
            answers: newArr,
            [id]: event.target.value
        })
    }

    getFeedback = () => {
        //WE GRAB THIS BECAUSE IN THE FUTURE THIS WILL BE RUN USING A CLOUD FUNCTION TO REDUCE
        //FRONT END LOAD BUT CLIENT WANTS END TO END ASAP SO WE GO HACKY
        // console.log(creds.fb.auth().currentUser.email)
        var score = 0;
        const answers = this.state.answers;
        const questions = this.state.test.questions;
        var correctArr = []
        var tryAgainArr = []
        
        answers.map(answer => { 
            questions.map(question => {
                if(answer.id === question.id){
                   if (answer.value == question.correctAns) {
                       score = score + parseInt(question.weight)
                       correctArr.push({id: question.id, result: true, tags: question.tags, weight: question.weight, question: question.questionText})
                   } else {
                    //    console.log('You got this question wrong: ' + question.questionText)
                       if (score < 1){
                        correctArr.push({id: question.id, result: false, tags: question.tags, weight: question.weight, question: question.questionText})
                        tryAgainArr.push({id: question.id, result: false, tags: question.tags, question: question.questionText, weight: question.weight})
                       } else {
                           correctArr.push({id: question.id, result: false, tags: question.tags, weight: question.weight, question: question.questionText})
                           tryAgainArr.push({id: question.id, result: false, tags: question.tags, question: question.questionText, weight: question.weight})
                       }
                   }
                //    console.log(score)
            } else { console.log('not the right one', answer.id, question.id)}})
        })
        if (score > 0) { 
            this.setState({
                score: Math.round((((score / this.state.test.totalMarks) * 100) * 100)/100),
                perQuestion: correctArr,
                wrongQuestions: tryAgainArr
            }) 
        } else {
            // console.log('score was less than 1', score)
            this.setState({
                score: '0',
                perQuestion: correctArr,
                wrongQuestions: tryAgainArr
            }) 
        }
    }

    handleClickOpen = () => {
        if (!this.state.warning){
            window.alert('Your first attempt will count as the recorded score for this task. Any subsequent attempts will count as practice only – the scores will not be submitted.')
        }
        this.finish(this.state.answers)
        this.setState({ open: true, warning: true });
        this.getFeedback()
    };
    
    handleClose = () => {
        if (!this.state.test.isTest) {
            this.setState({ 
                open: false,
                imgOpen: false,
                score: 0,

            });
        } else {
            this.setState({
                ...this.state,
                open: false
            })
        }
    };

    handleClose2 = () => {
        this.setState({ 
            open: false,
            imgOpen: false,
            score: 0,
            activeImg: '',
            ansImg: '',
            ansOpen: false,
        });
    };

    handleClose3 = () => {
        this.setState({
            ...this.state,
            taskLockedAlert: false
        })
        this.finish()
        this.handleClickOpen()
    }
    


    finish = async () => {
        const fullDate = new Date()
        var onTime = false
        var difference = 0
        var arr = []
        var alreadyComplete = false
        await db.collection('AssignedTasks').doc(this.state.testTitle).get()
            .then(snapshot => {
                const deadline = new Date(snapshot.data().Deadline)
                console.log(fullDate)
                console.log(deadline)
                difference = Math.round((((deadline - fullDate) / 86400000)) * 100) / 100
                difference >  0 ? onTime = true : onTime = false
                arr = snapshot.data().AssignedTo
            })
            arr.forEach(student => { 
                if (student.Student == this.props.match.params.id) { 
                    var index = arr.indexOf(student)
                    var thisStudent = arr.splice(index, 1)
                    console.log(thisStudent)
                    if (student.CompletionDate != 'N/A'){
                        // this.setState({
                        //     ...this.state,
                        //     open: false
                        // })
                        alreadyComplete = true
                    }
                }
            })
        if (alreadyComplete){
            return
        }
        var newObj = {
                    'Student': sessionStorage.getItem('uid'),
                    'Score': parseInt(this.state.score),
                    'CompletionDate': fullDate,
                    'perQuestion': this.state.perQuestion,
                    'Answers': this.state.answers,
                    'onTime': onTime,
                    'punctuality': difference,
                    'displayName': this.state.myName
                };
                arr.push(newObj)
                // console.log(arr, this.state.testTitle, this.state.myName)
        db.collection('AssignedTasks').doc(this.state.testTitle).set({
            'AssignedTo': arr}, {merge: true})
            .then(() => {
                if (this.state.test.isTest) {
                    this.setState({
                        disableQuestions: true
                    })
                } else { 
                    //do nothing?
                }
                window.alert('Submission Complete')
            })
    }

    getImages =  (data) => { 
        // console.log('DATA', data)
        // var storageRef = creds.fb.storage()
        // var imgRef = storageRef.ref('/images/' + this.state.testTitle + '/' + data)
        // const url =  imgRef.getDownloadURL()
        // return <img src={url} />
    }


    viewImg = (open, name) => {
        // console.log('ACTIVE', name)
        this.setState({
            activeImg: name, 
            imgOpen: open,
        })
    }

    viewAns = (open, name) => {
        // console.log('NAME', name)
        this.setState({
            ansImg: name, 
            ansOpen: open,
        })
    }

    displayImg = (img) => {
        console.log('ACTIVE2', img, img.src, this.state.activeImg, this.state)
        return <div style={{margin: 'auto', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyItems: 'center'}}><img height='100%' width='100%'  src={img.src} /></div>
    }

    displayAns = (img) => {
        // console.log('HERE', img, this.state.ansImg)
        return <div style={{margin: 'auto', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyItems: 'center'}}><img height='100%' width='100%'  src={img.src} /></div>
    }

    openImgInNewTab = (img) => {
        console.log(img)
        if (img){
            window.open(img.src, null, false)
        }
    }

    getAnswerImg = (file) => { 
        var images = this.state.images;
        var output;
        images.forEach( img => { 
            // console.log(img, img.file, file)
            if (img.file == file){
                output = img.url
            }
        })
        
        return output
    }

     render(){
        if (this.state.test) {
        const { classes } = this.props;
        return (
            <div>
                <Paper className={ classes.root } elevation={1}>
                    <Typography variant='headline'>
                        {this.state.testTitle}
                    </Typography>
                    <br/>
                    <Divider/>
                    {!this.state.disableQuestions ? 
                    <div className={classes.container}>
                        {this.state.test.questions.map(question => {
                            let index = this.state.test.questions.indexOf(question)
                            return (
                                <div style={{display: 'block', width: '75%', margin: 'auto'}}>
                                <Paper className={classes.container} elevation={1}>
                                    <Typography variant='headline' style={{width: '100%'}}>
                                        {question.id + ' - ' + question.title}
                                        <Divider/>
                                        <br/>
                                    </Typography>
                                    <br/>
                                    <br/>
                                    <Typography variant='title' style={{width: '100%'}}>
                                        Question:
                                    </Typography>
                                    <br/>
                                    <br/>
                                    <TextField
                                        id='question'
                                        style={{width: '100%'}}
                                        multiline
                                        value={question.questionText}
                                    />
                                    <br/>
                                    {question.tags.map(tag => {
                                        return (
                                            <Typography variant='body1'>
                                                {question.tags.indexOf(tag) == 0 ?
                                                    new String('Areas: ' + tag + ', ')
                                                :
                                                    new String(tag + ', ')
                                                    
                                                }
                                                
                                            </Typography>
                                        )
                                    })}
                                    <div style={{float: 'right', width: '100%'}}>
                                        <div style={{height: 104, width: 140, marginBottom: 'auto', paddingTop: 10, paddingBottom: 20}}>
                                        
                                        {question.file != null ? 
                                            <div>
                                                <Button onClick={() => this.viewImg(!this.state.imgOpen, question.id)}>
                                                    <img id={question.id} alt={question.file} className={classes.media} src={this.state[question.file]}/>
                                                </Button>
                                                <Button variant='raised' onClick={() => this.viewImg(!this.state.imgOpen, question.id)}>
                                                    Detailed View
                                                </Button>
                                            </div>
                                            :
                                            <Typography variant='caption' style={{margin: 'auto', paddingTop: 20}}>
                                                {'No image was provided for this Question'}
                                            </Typography>
                                        }
                                        <br/>
                                        </div>
                                        <div style={{width: '100%', paddingTop: 50}}>
                                            <FormControl component="fieldset" required className={classes.formControl}>
                                                <FormLabel component="legend">Select the correct answer</FormLabel>
                                                <RadioGroup
                                                    aria-label="Answers"
                                                    name="gender1"
                                                    className={classes.group}
                                                    value={this.state[question.id]}
                                                    onChange={this.pickAnswer(question.id, this.value)}
                                                >
                                                {question.answers.map(answer => {
                                                        // console.log('STATE IMAGES', this.state.images, this.getAnswerImg(answer.file))
                                                        if (answer.file){
                                                        
                                                                return (
                                                                    <FormControlLabel value={answer.value} control={<Radio/>} label={<Button onClick={() => this.viewAns(!this.state.ansOpen, answer.file)}><img id={answer.file} src={this.getAnswerImg(answer.file)} alt='image for answer' style={{ height: 150, width: 150}}/></Button>}disabled={this.state.timerComplete}/>
                                                                )
                                                            
                                                        
                                                        } else {
                                                            return (
                                                                <FormControlLabel value={answer.value} control={<Radio/>} label={answer.value} disabled={this.state.timerComplete}/>
                                                            )
                                                            
                                                        }
                                                        
                                                })}
                                                </RadioGroup>
                                                <br/>
                                                {
                                                question.weight > 1 ? 
                                                <div>
                                                    <Typography variant='body2' style={{marginTop: 10, float: 'bottom'}}>
                                                        {question.weight + ' Marks'}
                                                    </Typography>
                                                </div>
                                            :
                                                <div>
                                                    <Typography variant='body2' style={{marginTop: 10, float: 'bottom'}}>
                                                        {question.weight + ' Mark'}
                                                    </Typography>
                                                </div>
                                            }
                                            </FormControl>
                                            
                                        </div>
                                    </div>
                                    </Paper>
                                    <br/>
                                </div>
                            )
                        })}
                    </div>
                    :
                    <div style={{width: '100%'}}>
                        <br/>
                            <Typography variant='title' style={{width: '100%'}}>
                                {'You have finished this test, thanks. '}
                            </Typography>
                        <br/>
                    </div>
                    }
                    <Button className={classes.button} variant='outlined' onClick={() => this.handleClickOpen()} disabled={this.state.answers.length != this.state.test.questions.length}>
                        Finish Sheet
                    </Button>
                </Paper>
                <Dialog
                    open={this.state.open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    >
                    <DialogTitle id="alert-dialog-slide-title">
                        {"Test feedback for: " + this.state.testTitle}
                    </DialogTitle>
                    
                        {this.state.score ? (
                            
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description" className={classes.container}>
                                <Divider/>
                                <span style={{width: '100%'}} >
                                    <Typography variant='title' >
                                        {'You scored ' + this.state.score + '%'}
                                        <Divider/>
                                    </Typography>
                                </span>
                                <br/>
                                <br/>
                                <div style={{width: '100%'}}>
                                <Typography variant='subheading'>
                                    You need to revise these questions: 
                                </Typography>
                                </div>
                                <Divider/>
                                <br/>
                                <br/>
                                <div>
                                    {this.state.wrongQuestions.map(question => { 
                                        return (
                                            <div>
                                                <Typography variant='subheading'>
                                                    {question.id + ': ' + question.question + ' ' }
                                                    {'- ' + question.weight + ' marks'}
                                                </Typography>
                                                <Typography variant='caption'>
                                                    {'Areas: ' + question.tags.map(tag => { 
                                                        tag = tag + ', '
                                                        return tag
                                                    })}
                                                </Typography>
                                                <br/>
                                            </div>
                                        )
                                    })}
                                </div>
                                </DialogContentText>
                            </DialogContent>
                            
                        ) : (<div className={classes.root}>
                                <Typography variant='body1'>
                                    <CircularProgress className={classes.progress} size={50} />
                                </Typography>
                            </div>
                        )}
                        
                     <DialogActions>
                        <Button onClick={this.handleClose} color="primary" disabled={this.state.test.isTest}>
                            Try again
                        </Button>
                        <Button onClick={this.handleClose} color="primary">
                            close
                        </Button>
                    </DialogActions>
                            
                    
                </Dialog>
                {/* EXPANDED VIEW */}
                <Dialog
                    open={this.state.imgOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose2}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    >
                    <DialogContent>
                        <Card
                            className={classes.card2}
                        >
                            <CardMedia>
                                <div className={classes.cardMedia}>
                                    {this.state.activeImg ? this.displayImg(document.getElementById(this.state.activeImg)) : console.log('No Active image yet', this.state)}
                                </div>
                            </CardMedia>
                            <CardContent>
                                {/* <Typography gutterBottom variant="display1" component="h2">
                                    {this.state.activeImg}
                                </Typography> */}
                                <div  component="p">
                                    {this.state.test.questions.map(question => {
                                       if (question.id == this.state.activeImg) {
                                        //    console.log('MATCHHHH', question.id, this.state.activeImg, question)
                                            return (
                                                <div>
                                                <Typography variant='headline'>
                                                    {question.questionText}
                                                </Typography>
                                                <hr/>
                                                
                                                    <Typography variant='button'>
                                                        Answers:
                                                    </Typography>
                                                    <FormControl component="fieldset" required className={classes.formControl}>
                                                        <span>
                                                        {question.answers.map(answer => {
                                                                    // console.log('STATE IMAGES', this.state.images, this.getAnswerImg(answer.file))
                                                                    if (answer.file){
                                                                        return (
                                                                            <Button onClick={() => this.openImgInNewTab(document.getElementById(answer.file))}>
                                                                                <img id={answer.file} src={this.getAnswerImg(answer.file)} alt={answer.value} style={{ height: 200, width: 200, margin: 10}}/>
                                                                            </Button>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <div style={{ margin: 5,  }}>
                                                                                <Button  variant='outlined' style={{width: 200}}>
                                                                                    {answer.value}
                                                                                </Button>
                                                                            </div>
                                                                        )
                                                                    }
                                                            })}
                                                            </span>
                                                            <hr/>
                                                    </FormControl>
                                                    {question.tags.length > 0 ? 
                                                        <Typography variant='caption'>
                                                            Areas: {question.tags.map(tag => { 
                                                                return tag + ', '
                                                            })}
                                                            
                                                        </Typography>
                                                    :
                                                        <div/>
                                                    }
                                                    <br/>
                                                    <Typography variant='subheading'>
                                                        {question.weight + ' Marks'}
                                                    </Typography>
                                                </div>
                                            )
                                       }
                                    })}
                                </div>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary" onClick={() => this.openImgInNewTab(document.getElementById(this.state.activeImg))}>
                                    View Fullscreen
                                </Button>
                            </CardActions>
                        </Card>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.ansOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose2}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    >
                    <DialogContent>
                        <Card
                            className={classes.card2}
                        >
                            <CardMedia>
                                <div className={classes.cardMedia}>
                                    {this.state.ansImg ? this.displayImg(document.getElementById(this.state.ansImg)) : console.log('No Answer image yet', this.state.ansImg, this.state)}
                                </div>
                            </CardMedia>
                            <CardContent>
                                {/* <Typography gutterBottom variant="headline" component="h2">
                                    {this.state.ansImg}
                                </Typography> */}
                                {/* <Typography variant='subheading' component="p">
                                    {this.state.test.questions.map(question => {
                                        var text = ''
                                       if (question.id == this.state.activeImg) {
                                           console.log(question.questionText)
                                           return text = question.questionText
                                       }
                                       return text

                                    })}
                                </Typography> */}
                            </CardContent>
                            <CardActions>
                                {/* <Button size="small" color="primary" onClick={() => this.openImgInNewTab(<div style={{margin: 'auto', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyItems: 'center'}}><img height='100%' width='100%'  src={this.getAnswerImg(this.state.ansImage)} /></div> )}> */}
                                <Button size="small" color="primary" onClick={() => this.openImgInNewTab(document.getElementById(this.state.ansImg))}>
                                    View Fullscreen
                                </Button>
                            </CardActions>
                        </Card>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.taskLockedAlert}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose3}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        {"Time limit reached."}
                    </DialogTitle>
                    <Divider/>
                    <DialogContent>
                        <Typography vairant="subheading">
                                    The allotted time to complete this task has been reached. Your progress has been saved and you will recieve feedback. 
                        </Typography>
                    </DialogContent>
                    <br/>
                    <DialogActions>
                        <Button size='small' color='primary' onClick={ () => this.handleClose3()}>
                                    Ok
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* <Modal
                    className={classes.modal}
                    open={true}
                    hideBackdrop={true}
                    disableAutoFocus={true}
                /> */}
                {
                    this.state.timerComplete ? 
                        <div/>
                    :
                        <Card
                            className={classes.card}
                        >
                            <div style={{margin: 20, backgroundColor: 'inherit', color: 'white'}}>
                                <Typography variant='title' color='inherit'>
                                        Time Remaining: {this.state.timeRemaining} 
                                </Typography>
                            </div>
                        </Card>
                }
                
            </div>
        )
    } else { 
        return (<div/>)
    }
}
}
export default withStyles(styles)(SitHwk);


// render(){
//     if (this.state.test) {
//     const { classes } = this.props;
//     return (
//         <div>
//             <Paper className={ classes.root } elevation={1}>
//                 <Typography variant='headline'>
//                     {this.state.testTitle}
//                 </Typography>
//                 <br/>
//                 {this.state.timeLimit != undefined ? 
//                     <Typography variant='title' id='timer'> 
//                         {this.state.timeRemaining} 
//                     </Typography>
//                 :
//                     <div/>
//                 }
//                 <Divider/>
//                 {!this.state.disableQuestions ? 
//                 <div className={classes.container}>
//                     {this.state.test.questions.map(question => {
//                         let index = this.state.test.questions.indexOf(question)
//                         return (
//                             <div style={{display: 'block', width: '75%', margin: 'auto'}}>
//                             <Paper className={classes.container} elevation={1}>
//                                 <Typography variant='headline' style={{width: '100%'}}>
//                                     {question.id + ' - ' + question.title}
//                                     <Divider/>
//                                     <br/>
//                                 </Typography>
//                                 <br/>
//                                 <br/>
//                                 <Typography variant='title' style={{width: '100%'}}>
//                                     {'Question: ' + question.questionText}
//                                     <br/>
//                                 </Typography>
                                
//                                 <br/>
//                                 {question.tags.map(tag => {
//                                     return (
//                                         <Typography variant='body1'>
//                                             {question.tags.indexOf(tag) == 0 ?
//                                                 new String('Areas: ' + tag + ', ')
//                                             :
//                                                 new String(tag + ', ')
                                                
//                                             }
                                            
//                                         </Typography>
//                                     )
//                                 })}
//                                 <div style={{float: 'right', width: '100%'}}>
//                                     <div style={{height: 104, width: 140}}>
//                                     {question.file != null ? 
//                                         <Button onClick={() => this.viewImg(!this.state.imgOpen, question.id)}>
//                                             <img id={question.id} alt='Image to support question' className={classes.media}/>
//                                         </Button>
//                                         :
//                                         <Typography variant='caption' style={{margin: 'auto', paddingTop: 20}}>
//                                             {'No image was provided for this Quesiton'}
//                                         </Typography>
//                                     }
//                                     </div>
//                                     <Typography variant='body2' style={{float: 'bottom'}}>
//                                         {question.weight + ' Marks'}
//                                     </Typography>
//                                     <FormControl component="fieldset" required className={classes.formControl}>
//                                         <FormLabel component="legend">Select the correct answer</FormLabel>
//                                         <RadioGroup
//                                             aria-label="Answers"
//                                             name="gender1"
//                                             className={classes.group}
//                                             value={this.state[question.id]}
//                                             onChange={this.pickAnswer(question.id, this.value)}
//                                         >
//                                         {question.answers.map(answer => {
//                                             return (
//                                             <FormControlLabel value={answer.value} control={<Radio/>} label={answer.value} disabled={this.state.timerComplete}/>
//                                             )
//                                         })}
//                                         </RadioGroup>
//                                     </FormControl>
//                                 </div>
//                                 </Paper>
//                                 <br/>
//                             </div>
//                         )
//                     })}
//                 </div>
//                 :
//                 <div style={{width: '100%'}}>
//                     <br/>
//                         <Typography variant='title' style={{width: '100%'}}>
//                             {'You have finished this test, thanks. '}
//                         </Typography>
//                     <br/>
//                 </div>
//                 }
//                 <Button className={classes.button} variant='outlined' onClick={() => this.handleClickOpen()} disabled={this.state.answers.length != this.state.test.questions.length}>
//                     Finish Sheet
//                 </Button>
//             </Paper>
//             <Dialog
//                 open={this.state.open}
//                 TransitionComponent={Transition}
//                 keepMounted
//                 onClose={this.handleClose}
//                 aria-labelledby="alert-dialog-slide-title"
//                 aria-describedby="alert-dialog-slide-description"
//                 >
//                 <DialogTitle id="alert-dialog-slide-title">
//                     {"Test feedback for: " + this.state.testTitle}
//                 </DialogTitle>
                
//                     {this.state.score ? (
                        
//                         <DialogContent>
//                             <DialogContentText id="alert-dialog-slide-description" className={classes.container}>
//                             <Divider/>
//                             <span style={{width: '100%'}} >
//                                 <Typography variant='title' >
//                                     {'You scored ' + this.state.score + '%'}
//                                     <Divider/>
//                                 </Typography>
//                             </span>
//                             <br/>
//                             <br/>
//                             <Typography variant='subheading'>
//                                 {'You need to revise these questions:'}
//                                 <Divider/>
//                             </Typography>
//                             <br/>
//                             <br/>
//                             <div>
//                                 {this.state.wrongQuestions.map(question => { 
//                                     return (
//                                         <div>
//                                             <Typography variant='subheading'>
//                                                 {question.id + ': ' + question.question + ' ' }
//                                                 {'- ' + question.weight + ' marks'}
//                                             </Typography>
//                                             <Typography variant='caption'>
//                                                 {'Areas: ' + question.tags.map(tag => { 
//                                                     tag = tag + ', '
//                                                     return tag
//                                                 })}
//                                             </Typography>
//                                             <br/>
//                                         </div>
//                                     )
//                                 })}
//                             </div>
//                             </DialogContentText>
//                         </DialogContent>
                        
//                     ) : (<div className={classes.root}>
//                             <Typography variant='body1'>
//                                 <CircularProgress className={classes.progress} size={50} />
//                             </Typography>
//                         </div>
//                     )}
                    
//                  <DialogActions>
//                             <Button onClick={this.handleClose} color="primary" disabled={this.state.test.isTest}>
//                                 Try again
//                             </Button>
//                             <Button onClick={() => this.finish(this.state.answers)} color="primary">
//                                 Finish
//                             </Button>
//                         </DialogActions>
                        
                
//             </Dialog>
            
//             <Dialog
//                 open={this.state.imgOpen}
//                 TransitionComponent={Transition}
//                 keepMounted
//                 onClose={this.handleClose2}
//                 aria-labelledby="alert-dialog-slide-title"
//                 aria-describedby="alert-dialog-slide-description"
//                 >
//                 <DialogContent>
//                     <Card
//                         className={classes.card}
//                     >
//                         <CardMedia>
//                             <div className={classes.cardMedia}>
//                                 {this.state.activeImg ? this.displayImg(document.getElementById(this.state.activeImg)) : console.log('No Active image yet')}
//                             </div>
//                         </CardMedia>
//                         <CardContent>
//                             <Typography gutterBottom variant="headline" component="h2">
//                                 {this.state.activeImg}
//                             </Typography>
//                             <Typography variant='subheading' component="p">
//                                 {this.state.test.questions.map(question => {
//                                     var text = ''
//                                    if (question.id == this.state.activeImg) {
//                                        console.log(question.questionText)
//                                        return text = question.questionText
//                                    }
//                                    return text

//                                 })}
//                             </Typography>
//                         </CardContent>
//                         <CardActions>
//                             <Button size="small" color="primary" onClick={() => this.openImgInNewTab(document.getElementById(this.state.activeImg))}>
//                                 View Fullscreen
//                             </Button>
//                         </CardActions>
//                     </Card>
                    
//                 </DialogContent>
//             </Dialog>

//             <Dialog
//                 open={this.state.taskLockedAlert}
//                 TransitionComponent={Transition}
//                 keepMounted
//                 onClose={this.handleClose3}
//                 aria-labelledby="alert-dialog-slide-title"
//                 aria-describedby="alert-dialog-slide-description"
//             >
//                 <DialogTitle id="alert-dialog-slide-title">
//                     {"Time limit reached."}
//                 </DialogTitle>
//                 <Divider/>
//                 <DialogContent>
//                     <Typography vairant="subheading">
//                                 The allotted time to complete this task has been reached. Your progress has been saved and you will recieve feedback. 
//                     </Typography>
//                 </DialogContent>
//                 <br/>
//                 <DialogActions>
//                     <Button size='small' color='primary' onClick={ () => this.handleClose3()}>
//                                 Ok
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </div>
//     )
// } else { 
//     return (<div/>)
// }
// }
// }
// export default withStyles(styles)(SitHwk);







// WEBPACK FOOTER //
// ./src/pages/View/takeHWK.jsx